<script lang="ts">
    import { reviewsIconCollectionManagerContextToken } from "@apps/reviews/context_tokens";
    import Icon from "@components_v2/Icon.svelte";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import CN from "classnames";

    export let rating: number;
    export let showIconTitle = true;
    export let iconTitle = "Rating";
    export let emptyIconTitle = "";

    let className: string | null = null;
    export { className as class };
    export let starsSize = 20;

    const iconCollection$ = getTypedContext(
        reviewsIconCollectionManagerContextToken
    ).getIconCollection();
</script>

<div
    class={CN("gw-rv-rating-stars gw-default-reset", className)}
    aria-label={`${rating} out of 5 ratings`}
    role="img"
>
    {#each [1, 2, 3, 4, 5] as starNumber}
        {#if rating * 2 > starNumber * 2 - 1}
            <Icon
                width={starsSize}
                height={starsSize}
                class="gw-rv-rating-stars__star"
                title={showIconTitle
                    ? `${iconTitle} star ${starNumber}, full`
                    : undefined}
            >
                <svelte:component this={$iconCollection$?.filled} />
            </Icon>
        {:else if rating * 2 > starNumber * 2 - 2}
            <Icon
                width={starsSize}
                height={starsSize}
                class="gw-rv-rating-stars__star-half"
                title={showIconTitle
                    ? `${iconTitle} star ${starNumber}, half`
                    : undefined}
            >
                <svelte:component this={$iconCollection$?.half} />
            </Icon>
        {:else}
            <Icon
                width={starsSize}
                height={starsSize}
                class="gw-rv-rating-stars__star-empty"
                title={showIconTitle ? emptyIconTitle : undefined}
            >
                <svelte:component this={$iconCollection$?.empty} />
            </Icon>
        {/if}
    {/each}
</div>

<style>
    .gw-rv-rating-stars {
        display: flex;
    }
    :global(.gw-rv-rating-stars__star) {
        color: var(--gw-rv-icon-starColor);
    }
    :global(.gw-rv-rating-stars__star-half) {
        color: var(--gw-rv-icon-starColor);
    }
    :global(.gw-rv-rating-stars__star-empty) {
        color: var(--gw-rv-icon-starColor);
    }
</style>
